import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  :root {
    /* BACKGROUNDS */
    --bg-orange : #FFB900;
    --bg-darkGrey : #EBEBEB;
    --bg-green : #6BB700;
    /* colors */
    --color-primary : #5B5FC7;
    --color-danger :  #c4314b;
    --color-success :  #237B4B;
    --color-link : #0067B8;
    /* hvoers */
    --color-primary--hover : hsla(349, 60%, 48%, 0.93);
    /* sizes */
    --header-height : 70px;
  }

  * {
    margin: 0px;
    padding: 0px;
    box-sizing: border-box;
    font-family: "Segoe UI","Trebuchet MS", 'Noto Sans', Arial, sans-serif;
  }
  
  body {
    min-height:100vh;
  }
  div:has(> .popup) {
    padding: 0px;
    padding-bottom: 16px;
  }
`;
